module.exports = __webpack_public_path__ + "static/media/image_35.d98300fa.png";